<template lang="pug">
el-dialog.modal-inibir-restricoes(
    :visible.sync='mostrarDialog',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    width='30%'
)
    div(
        style='background: white; height: auto; padding: 20px; border-radius: 5px'
    )
        section.mb-4.template(slot='title')
            .modal-inibir-restricoes__header
                .modal-inibir-restricoes__header--icon
                    i.el-icon-edit
                .modal-inibir-restricoes__header--title
                    | Editar restrições

        section.modal-inibir-restricoes__body
            .modal-inibir-restricoes__body--descricao
                div(v-html='identificarLabelRestricoes()')

                .modal-inibir-restricoes__body--form
                    el-form(
                        label-position='top',
                        ref='formInibirRestricoes',
                        :model='payload',
                        :rules='formRules'
                    )
                        el-form-item(
                            prop='operacoes',
                            v-if='this.operacoes.length > 0'
                        )
                            template(slot='label')
                                span.label Selecionar operações
                            el-checkbox(
                                v-model='selecionarTodas',
                                @change='alterarCheckbox()'
                            ) Selecionar todas
                            el-select.w-100(
                                v-model='payload.idsOperacoes',
                                multiple,
                                filterable,
                                collapse-tags,
                                placeholder='Clique para selecionar',
                                value-key='id',
                                @change='verificarCheckbox()'
                            )
                                el-option(
                                    v-for='operacao in operacoes',
                                    :key='operacao.id',
                                    :label='montarLabelOpcoes(operacao)',
                                    :value='operacao.id'
                                )

                        el-form-item(prop='justificativa')
                            template(slot='label')
                                span.label.campo_obrigatorio Selecionar justificativa
                            el-select.w-100(
                                v-model='payload.idJustificativa',
                                placeholder='Clique para selecionar',
                                value-key='id'
                            )
                                el-option(
                                    v-for='justificativa in justificativas',
                                    :key='justificativa.id',
                                    :label='justificativa.nome',
                                    :value='justificativa.id'
                                )

                        el-form-item(prop='descricao')
                            template(slot='label')
                                span.label Descrição

                            el-input(
                                v-model='payload.descricaoJustificativa',
                                type='textarea',
                                :rows='3',
                                placeholder='Digite aqui sua justificativa...'
                            )

        section.modal-inibir-restricoes__action
            BaseButton(size='mini', @click='fechar')
                | Voltar
            BaseButton(type='primary', size='mini', @click='editarRestricao')
                | Salvar
</template>

<script>
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import DiagnosticoSociambientealRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEdicaoRestricoesCdaWa',
    components: {
        DiagnosticoSociambientealRepresentante,
        BaseButton
    },

    props: {
        idOperacao: {
            required: true
        },
        codigoCamada: {
            type: String,
            required: true
        },
        codigoRestricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mostrarDialog: false,
            selecionarTodas: false,
            payload: {
                codigoCamada: null,
                codigoRestricao: null,
                idsOperacoes: [],
                idJustificativa: null,
                descricaoJustificativa: null
            },
            formRules: {
                justificativa: [
                    { validator: this.checkRuleJustificativa, trigger: 'blur' }
                ],
                descricao: [
                    { validator: this.checkRuleDescricao, trigger: 'blur' }
                ]
            },
            operacoes: [],
            justificativas: []
        };
    },

    watch: {
        mostrarDialog: function (value) {
            if (value) {
                this.payload.codigoCamada = this.codigoCamada;
                this.payload.codigoRestricao = this.codigoRestricao;
                this.buscarJustificativas();
                this.buscarDadosInibicao();
            }
        }
    },

    mounted() {
        this.verificarCheckbox();
    },

    methods: {
        async buscarDadosInibicao() {
            await OperacaoCdaWaService.buscarDadosInibicao({
                idOperacao: this.idOperacao,
                codigoRestricao: this.codigoRestricao
            })
                .then(({ data }) => {
                    this.payload.idJustificativa = data.idJustificativa;
                    this.payload.descricaoJustificativa = data.descricao;
                    this.payload.idsOperacoes = data.operacoesSelecionadas;
                    this.operacoes = data.operacoes;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar a inibição da restrição.'
                    })
                );
        },
        async buscarJustificativas() {
            await OperacaoCdaWaService.buscarJustificativasInibirRestricoes()
                .then(({ data }) => {
                    this.justificativas = data.itens;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar as justificativas para edição da inibição'
                    });
                    this.fechar();
                });
        },
        checkRuleJustificativa(rule, value, callback) {
            if (this.payload.idJustificativa === null) {
                return callback(
                    new Error('Escolha pelo menos uma justificativa')
                );
            }
            callback();
        },
        checkRuleDescricao(rule, value, callback) {
            if (this.payload.descricaoJustificativa?.length > 1000) {
                return callback(
                    new Error('Descrição muito longa. Máximo 1000 caracteres')
                );
            }
            callback();
        },
        async editarRestricao() {
            const formValidado = await this.$refs.formInibirRestricoes
                .validate()
                .then(value => value)
                .catch(() => false);

            if (!formValidado) return;

            this.payload.idsOperacoes.push(this.idOperacao);
            await OperacaoCdaWaService.editarRestricao(this.payload)
                .then(({ data }) => {
                    this.$notify.success({
                        message: data,
                        duration: 10000
                    });
                    this.fechar();
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível editar a restrição. ' +
                            'Se o problema persistir, entre em contato com suporte.'
                    });
                    this.fechar();
                })
                .finally(() => {
                    this.payload = {
                        codigoCamada: null,
                        codigoRestricao: null,
                        idsOperacoes: [],
                        idJustificativa: null,
                        descricaoJustificativa: null
                    };
                });
        },
        alterarCheckbox() {
            this.payload.idsOperacoes = [];
            if (this.selecionarTodas) {
                this.operacoes.forEach(operacao => {
                    this.payload.idsOperacoes.push(operacao.id);
                });
            }
        },
        verificarCheckbox() {
            if (this.payload.idsOperacoes.length === this.operacoes.length) {
                this.selecionarTodas = true;
            } else {
                this.selecionarTodas = false;
            }
        },
        identificarLabelRestricoes() {
            if (this.operacoes.length > 0) {
                return `<span>A restrição se encontra em outra(s) ${this.operacoes.length} operação(ões).
                        Você também pode <b>edita-las</b> diretamente daqui.</span>`;
            } else {
                return '<span>Você está prestes a <b>editar</b> esta restrição.</span>';
            }
        },
        montarLabelOpcoes(operacao) {
            return (
                'ID: ' +
                operacao.identificador +
                ' | Nome: ' +
                (operacao.nome ? operacao.nome : '--')
            );
        },
        fechar() {
            this.selecionarTodas = false;
            this.mostrarDialog = false;
            this.payload = {
                codigoCamada: null,
                codigoRestricao: null,
                idsOperacoes: [],
                idJustificativa: null,
                descricaoJustificativa: null
            };
        }
    }
};
</script>

<style lang="scss">
.modal-inibir-restricoes {
    display: flex;

    .modal-inibir-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-inibir-restricoes__header--icon {
            margin-right: 10px;
            font-size: 20px;
            color: #fec556;
        }

        .modal-inibir-restricoes__header--title {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .modal-inibir-restricoes__body {
        width: 100%;

        .modal-inibir-restricoes__body--descricao {
            font-weight: 500;
            font-size: 14px;
            word-break: break-word;
        }
    }

    .modal-inibir-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-form-item__label {
        padding: 0 !important;
        margin-top: 5px !important;
    }

    .campo_obrigatorio::after {
        content: '*';
        color: red;
    }
}
</style>
